<template>
    <MainContent title="Crear equipo">
        <template v-slot:header>
            <h3 class="card-title">Crear equipo</h3>
        </template>
        <template v-slot:content>
            <div class="row" v-if="!loading">
                <div class="col-12">
                    <FormEquipo :equipo="equipo" @terminado="crearEquipo"/>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import FormEquipo from '@/components/backend/bases/equipos/FormEquipo';

    export default {    
        data() {
            return {
                equipo: {},
                loading: false,
                conf: {}
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        methods: {
            crearEquipo() {
                this.loading = true;

                this.equipo.filters = {};
                this.equipo.lista_id = this.lista_id;
                this.equipo.teatro_id = this.teatro.id;

                this.$store.dispatch(this.config.getVuexAlias('back.bases.equipos.crear'), this.equipo).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.bases.equipos', params: { lista_id: this.lista_id } });
                }).finally(() => this.loading = false);
            },
        },
        components: {
            MainContent, FormEquipo
        }
    }
</script>
